import { ivendedor } from './../models/ivendedor';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class VendedorService {

    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService
    ) { }

    public obtener(codven: number) {
        return this.httpClient.get(environment.serviceUrl + "vendedor/" + codven, { observe: 'response' },)
    }

    obtenerVendedores(desven: string): Observable<any> {
        this.apiService.setUrlPathApi("vendedor/buscar?");
        return this.apiService.execGetQueryJson(`desven=${desven}`)
    }

    buscarVendedor(codven: any) {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.vendedor_pago_CRUD_url);
        return this.apiService.execGetQueryJson(`/${codven}`)
    }

    insertarVendedor(data: ivendedor) {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.vendedor_pago_CRUD_url);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarVendedor(data: ivendedor) {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.vendedor_pago_CRUD_url);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminarVendedor(codven: any) {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.vendedor_pago_CRUD_url);
        return this.apiService.executeDeleteJson(`/${codven}`)
    }


}